module.exports = __webpack_public_path__ + "static/media/settings.e92279d9.svg";